import React from "react";
import { Select } from "@medentic/polaris-react";
import { useTranslation } from "react-i18next";
import { useCountries } from "@shared/hooks/common/useCountries";

interface CountryPickerProps {
  value: string | null;
  onChange: (value: string | null) => void;
  label?: string;
  error?: string | boolean;
  helpText?: string;
  disabled?: boolean;
  placeholder?: string;
  required?: boolean;
}

export const CountryPicker: React.FC<CountryPickerProps> = ({
  value,
  onChange,
  label,
  error,
  helpText,
  disabled = false,
  placeholder,
  required = false,
}) => {
  const { t } = useTranslation();
  const { countries, isLoading } = useCountries();

  const PLACEHOLDER_VALUE:string = "__placeholder__";

  // Create options array with placeholder option
  const options = [
    {
      label: placeholder || t("common.pickACountry"),
      value: PLACEHOLDER_VALUE,
      disabled: true,
    },
    ...countries
      .filter((country) => country.iso3 && country.iso3.trim() !== "") // Filter out empty iso3 values
      .map((country) => ({
        label: country.name,
        value: country.iso3,
      })),
  ];

  const handleChange = (selectedValue: string) => {
    // If placeholder is selected, return null
    if (selectedValue === PLACEHOLDER_VALUE || selectedValue === "") {
      onChange(null);
    } else {
      onChange(selectedValue);
    }
  };

  return (
    <Select
      label={label}
      options={options}
      value={value || PLACEHOLDER_VALUE}
      onChange={handleChange}
      error={error}
      helpText={helpText}
      disabled={disabled || isLoading}
      requiredIndicator={required}
      placeholder={placeholder || t("common.pickACountry")}
    />
  );
};

export default CountryPicker;